import request from './request'



// 下单
export function createOrder(data) {
  return request({
    url: `/Order/create`,
    method: 'post',
    data
  })
}

// 获取订单列表
export function orderPage(params) {
  return request({
    url: `/Order/page`,
    method: 'get',
    params
  })
}

// 获取产品详情
export function orderDetail(params) {
  return request({
    url: `/Order/detail`,
    method: 'get',
    params
  })
}

export function updateTransport(data) {
  return request({
    url: `/Order/updateTransport`,
    method: 'post',
    data
  })
}